import classNames from 'classnames'
import React, { ReactNode } from 'react'

import './Label.scss'

const Label = (
  props: React.LabelHTMLAttributes<HTMLLabelElement> & {
    icon?: ReactNode
    isRequired?: boolean
    text: ReactNode
  },
) => {
  const { children, icon, isRequired, text, className, ...baseProps } = props

  return (
    <label className={classNames('label', className)} {...baseProps}>
      <div
        className={classNames('label__text', {
          'label__text--required': isRequired,
        })}
      >
        {icon && <div className="label__icon">{icon}</div>}
        {text}
      </div>
      {children}
    </label>
  )
}

export default Label
